import I18n from "^/config/i18n";

export default function courseDetailsMapping() {
  return {
    bachelorOfArts: I18n.t("Course bach of arts"),
    bachelorOfScience: I18n.t("Course bach of science"),
    bachelorOfEngineering: I18n.t("Course bach of engineering"),
    masterOfScience: I18n.t("Course ms of science"),
    masterOfArts: I18n.t("Course ms of arts"),
    masterOfEngineering: I18n.t("Course ms of engineering"),
    masterOfBusinessAdm: I18n.t("Course ms of business adm"),
    master: I18n.t("Course master,"),
    bachelor: I18n.t("Course bachelor,"),
    technology: I18n.t("Course technology"),
    business: I18n.t("Course business"),
    informatics: I18n.t("Course informatics"),
    techcampus: "Heilbronn TechCampus",
    bildungscampus: "Heilbronn Bildungscampus",
    kuenzelsau: "Künzelsau",
    schwaebisch: "Schwäbisch Hall",
    summer: I18n.t("Course summer"),
    winter: I18n.t("Course winter"),
    full: I18n.t("Course full time"),
    coop: I18n.t("Course cooperative"),
    indepth: I18n.t("Course indepth"),
    work: I18n.t("Course part time"),
    external: I18n.t("Course external"),
    de: I18n.t("Course German"),
    en: I18n.t("Course English"),
    esp: I18n.t("Course Spanish"),
    Deutsch: I18n.t("Course German"),
    Englisch: I18n.t("Course English"),
    Spanish: I18n.t("Course Spanisch"),
    Studiengänge: I18n.t("Studiengänge"),
  };
}
